module.exports = __webpack_public_path__ + "static/media/john.6be24763.png";